import Service from '@/services/Service'

class DepartamentService extends Service {
  constructor() {
    super('DEPARTAMENTS')
    this.resource = 'departaments'
  }

  createRequestUrl(query) {
    let requestUrl = `${this.resource}?`

    if (query) query = this.encodeQueryValues(query)

    if (query.todos)
      requestUrl += this.hasParameter(requestUrl)
        ? `&TODOS=${query.todos}`
        : `TODOS=${query.todos}`
    else
      requestUrl += this.hasParameter(requestUrl)
        ? `&page=${query.page}`
        : `page=${query.page}`
    if (query.codigo)
      requestUrl += this.hasParameter(requestUrl)
        ? `&CODIGO=${query.codigo}`
        : `CODIGO=${query.codigo}`
    if (query.descricao)
      requestUrl += this.hasParameter(requestUrl)
        ? `&DESCRICAO=${query.descricao}`
        : `DESCRICAO=${query.descricao}`
    if (query.classificacao)
      requestUrl += this.hasParameter(requestUrl)
        ? `&CLASSIFICACAO=${query.classificacao}`
        : `CLASSIFICACAO=${query.classificacao}`
    return requestUrl
  }

  async getDepartaments(query = null) {
    let requestUrl = this.createRequestUrl(query)
    let response = await this.getAPI(requestUrl)
    return response
  }

  async getDepartament(id) {
    let requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    return await this.getAPI(requestUrl)
  }

  /* Obtém um código de departamento ao incluir novo departamento */
  async createDepartament() {
    let requestUrl = `${this.resource}/create`
    return await this.getAPI(requestUrl)
  }
}

export default new DepartamentService()
